import React from 'react';
import './AdvertisingGuide.css';

const AdvertisingGuide = () => {
  return (
    <div className="guide-container">
      <h1 className="guide-title">Advertising Guide</h1>
      
      <section className="guide-section">
        <h2 className="guide-heading">1. Registration and Profile Selection</h2>
        <p>
          Go to <a href="https://coinstatshub.tech/register">https://coinstatshub.tech/register</a> and sign up on the platform.
          Choose a profile that fits your needs: User, Miner, Promoter, Investor, or Project CEO.
        </p>
      </section>

      <section className="guide-section">
        <h2 className="guide-heading">2. Profile Setup</h2>
        <p>
          Access your profile at <a href="https://coinstatshub.tech/user/profile">https://coinstatshub.tech/user/profile</a> 
          to enter your unique FuerteCoin (FUEC) address, check your available balance, and manage your UTXO transactions.
        </p>
      </section>

      <section className="guide-section">
        <h2 className="guide-heading">3. Choosing an Advertising Package</h2>
        <p>
          Visit the dashboard at <a href="https://coinstatshub.tech/dashboard">https://coinstatshub.tech/dashboard</a> to 
          select an advertising package from the active Advertising module.
        </p>
      </section>

      <section className="guide-section">
        <h2 className="guide-heading">4. Available Advertising Packages</h2>
        <ul>
          <li>
            <strong>Basic Package:</strong> 250x250 ad for 7 days, priced at 2,046,783.62573099 FUEC.
          </li>
          <li>
            <strong>Intermediate Package:</strong> 728x90 ad for 14 days, priced at 6,140,350.87719298 FUEC.
          </li>
          <li>
            <strong>Premium Package:</strong> 160x600 ad for 30 days, priced at 8,771,929.82456140 FUEC.
          </li>
          <li>
            <strong>Gold Package:</strong> 728x90 ad for 60 days, priced at 15,438,596.49122807 FUEC.
          </li>
          <li>
            <strong>Silver Package:</strong> 300x250 ad for 15 days, priced at 3,508,771.92982456 FUEC.
          </li>
        </ul>
      </section>

      <section className="guide-section">
        <h2 className="guide-heading">5. Security and Fraud Prevention</h2>
        <p>
          This system prevents fraud in promotions. At the time of price calculation, the 7-day average was 
          0.00000342 FUEC, ensuring price stability in terms of USDT.
        </p>
      </section>

      <section className="guide-section">
        <h2 className="guide-heading">6. Community and Transparency</h2>
        <p>
          All FUEC payments are burned at the official address: <strong>FEVimFGLThhSYKRvassLGx58DWKUJAAMgD</strong>. 
          This ensures that the value of these transactions benefits the community by reducing the circulating supply.
        </p>
      </section>

      <p className="guide-footer">
        Take advantage of CoinStatsHub's advertising services to boost your project and reach a broader audience!
      </p>
    </div>
  );
};

export default AdvertisingGuide;
